// src/pages/settings/MeterListInput.tsx — liste éditable de compteurs (PDL / PCE) id + libellé

import type { MeterEntry } from "./helpers";

export function MeterListInput({ values, onChange, label, idPlaceholder }:{
  values:MeterEntry[]; onChange:(v:MeterEntry[])=>void; label:string; idPlaceholder?:string;
}) {
  const add = () => onChange([...values, { id:"", label:"" }]);
  const upd = (i:number, field:"id"|"label", v:string) =>
    onChange(values.map((x,j) => j===i ? {...x,[field]:v} : x));
  const del = (i:number) => onChange(values.filter((_,j) => j!==i));
  return (
    <div className="mb-16">
      <label className="label">{label}</label>
      {values.length > 0 && (
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr auto",gap:6,marginBottom:4}}>
          <span style={{fontSize:10,color:"#aaa",paddingLeft:2}}>Identifiant</span>
          <span style={{fontSize:10,color:"#aaa",paddingLeft:2}}>Libellé</span>
          <span/>
        </div>
      )}
      {values.map((m,i)=>(
        <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr auto",gap:6,marginBottom:6,alignItems:"center"}}>
          <input value={m.id} onChange={e=>upd(i,"id",e.target.value)} className="field"
            style={{marginBottom:0,fontSize:12}} placeholder={idPlaceholder}/>
          <input value={m.label} onChange={e=>upd(i,"label",e.target.value)} className="field"
            style={{marginBottom:0,fontSize:12}} placeholder="ex : Bâtiment A"/>
          <button onClick={()=>del(i)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red)",fontSize:18,lineHeight:1}}>✕</button>
        </div>
      ))}
      <button onClick={add} style={{background:"none",border:"1px dashed #ccc",borderRadius:6,padding:"5px 12px",cursor:"pointer",fontSize:11,color:"#888",fontFamily:"var(--ff-title)"}}>
        ＋ Ajouter
      </button>
    </div>
  );
}
